<div class="container"  *ngIf = "viewContent && !displayContent && getHTMLData">
  
    <div class="closeButton"><span onclick="window.close()"><img src="/assets/images/EtisClose.gif"
                alt="Close" title="Close" width="12" height="11" border="0"></span>&nbsp;
        <span onclick="window.close()" title="Close" class="icon">{{'Close'|translate}}</span>
    </div>
  <!-- <div class="fdrs-view-card"> -->
    <div class="card-body fdrs-view-card-body">   
     <div class="fdrs-view-card1">
      <div class="card-body fdrs-view-card-body1">
          <div class="fdrs-view-tab-header">
              <label class="tab-header-label"></label> 
          </div>
        <div class="fdrs-view-content" [innerHTML]="displayHTML | pinpointPipe" ></div></div>
        <!-- <div class="fdrs-view-content">{{displayHTML}}</div> -->
      </div>
  </div></div>
  <!-- </div> -->
  <div  *ngIf = "viewContent && displayContent && getHTMLData">
    <div style="height: 22px;"></div>
    <div class="fdrs-view-content" [innerHTML]="displayHTML | pinpointPipe" ></div>
  </div>
  <div class="nospa-content" *ngIf="viewContent && !getHTMLData">
    <button type="button" class="btn btn-primary mr-3 shadow-none no-print nospa-closebtn" (click)="closePage()">{{'Close'|translate}}
    </button>
    <div class="nospa-header">{{'Information Not Available'|translate}}</div>
    <div class="nospa-title">{{'The information you have requested is not available at this time'|translate}}.</div>
  </div>
